import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DASHBOARD SUMMARY APIs (Financial Overview)
// RoleId/UserId drive backend CC-scoping: for roles with ApplicableForCC='Yes',
// results are restricted to the cost centers assigned to this user in UserCostCenters.
// ==============================================

// 1. Client Outstanding Summary (Receivables)
export const getClientOutStandingSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetClientOutStandingSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Client Outstanding Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Vendor Outstanding Summary (Payables)
export const getVendorOutStandingSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetVendorOutStandingSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Vendor Outstanding Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Stock Purchase Consolidate Summary (Tax Liabilities - previous calendar month GST)
export const getStockPurchaseConsolidateSummary = async ({ roleId, userId }) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetStockPurchaseConsolidateSummary`,
            { params: { RoleId: roleId, UserId: userId } }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Stock Purchase Consolidate Summary API Error:', error.response || error);
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
